module.exports = __webpack_public_path__ + "media/images/firsttime_header03_pc-03123e537481ab3af1b5a064328278b5.png";